import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Col, Form, Row } from "react-bootstrap";
import locationData from "../../countries.json";
import CustomSelect from "../CustomSelect";

const Residence = ({ formik }) => {
  const { t } = useTranslation();
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const data = locationData.map((country) => ({
      value: country.name,
      label: country.name,
    }));
    setCountries(data);
  }, []);

  return (
    <>
      <Row>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.address")} *</Form.Label>
          <Form.Control
            type="text"
            name="address"
            placeholder={t("form.address")}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.address}
            isInvalid={formik.touched.address && !!formik.errors.address}
          />
          <Form.Control.Feedback type="invalid">
            {t(`error.${formik.errors.address}`)}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.country")} *</Form.Label>
          <CustomSelect
            formik={formik}
            name="province"
            options={countries}
            placeholder={t("form.select")}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.city")} *</Form.Label>
          <Form.Control
            type="text"
            name="city"
            placeholder={t("form.city")}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.city}
            isInvalid={formik.touched.city && !!formik.errors.city}
          />
          <Form.Control.Feedback type="invalid">
            {t(`error.${formik.errors.city}`)}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.postcode")} *</Form.Label>
          <Form.Control
            type="text"
            name="postcode"
            placeholder={t("form.postcode")}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.postcode}
            isInvalid={formik.touched.postcode && !!formik.errors.postcode}
          />
          <Form.Control.Feedback type="invalid">
            {t(`error.${formik.errors.postcode}`)}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
    </>
  );
};

export default Residence;